import React from 'react';
import { Box, RadioButton, Typography } from '@saviynt/design-system';

import { CF_SEC_BLD } from '../../../../shared/constants';
import {
  useInvertedLocalize,
  useTypedSelector,
} from '../../../../shared/hooks';
import { CURRENT_VIEW_TYPES } from '../../data-layer/violationsReportConstants';

const ALL_STATUS: Record<string, string> = {
  openCount: 'Open',
  mitigatedCount: 'Mitigated',
  inReviewCount: 'Review',
  remediatedCount: 'Remediated',
  closedCount: 'Closed',
};

interface CurrentViewProps {
  onReportSelect?: (reportValue: string) => void;
  selectedReport?: string;
  appliedFiltersCount?: number;
}

/**
 * CurrentView
 */
function CurrentView({
  onReportSelect,
  selectedReport: propSelectedReport,
  appliedFiltersCount,
}: CurrentViewProps) {
  const l = useInvertedLocalize();
  const CURRENT_VIEW_REPORTS = ['summary', 'detail', 'permissions'];

  // Use prop selectedReport or fallback to summary for current view
  const currentSelectedReport = CURRENT_VIEW_REPORTS.includes(
    propSelectedReport || ''
  )
    ? propSelectedReport
    : 'summary';

  // Initialize local state with the correct report
  // useEffect(() => {
  //   const reportToSelect = selectedReport || defaultReport;

  //   if (reportToSelect !== localSelectedReport) {
  //     setLocalSelectedReport(reportToSelect);
  //   }
  // }, [selectedReport, defaultReport, localSelectedReport]);

  const { activeFilters, tabInAction } = useTypedSelector(
    (state) => state.aag.violationsTab.controls
  );

  // Prefer sanitized count passed from ReportModal; fallback to local derivation if missing
  const fallbackCount = activeFilters
    .map((f) => (f.options.some((o) => o.isChecked) ? 1 : 0))
    .reduce<number>((a, b) => a + b, 0);
  const filterCount =
    typeof appliedFiltersCount === 'number'
      ? appliedFiltersCount
      : fallbackCount;

  const filterText = `(${filterCount} ${l('Filters Applied')})`;
  const statusText = `(${l('Status:')} ${
    tabInAction ? ALL_STATUS[tabInAction] : ''
  })`;

  const currentViewTitle = (
    <Box className='ReportModal-templates-title-custom'>
      <Typography kind='h3' color={CF_SEC_BLD}>
        {l('Current View: User Violations')}{' '}
      </Typography>
      {filterCount ? (
        <Typography kind='body2' color={CF_SEC_BLD}>
          {filterText}
        </Typography>
      ) : (
        <Typography kind='body2' color={CF_SEC_BLD}>
          {statusText}
        </Typography>
      )}
    </Box>
  );

  const handleClick = (e: object, value: string) => {
    onReportSelect?.(value);
  };

  return (
    <Box className='ReportModal-templates'>
      <Box className='ReportModal-templates-title'>
        {currentViewTitle}
        <Typography kind='body2' color='--color-foreground-neutral-medium'>
          {l('You can update filters and columns during preview.')}
        </Typography>
      </Box>
      <Box>
        <Typography kind='h3'>{l('Type')}</Typography>
        <Typography kind='body2' color='--color-foreground-neutral-medium'>
          {l(
            'Choose the level of details you want to include. You can modify them during preview.'
          )}
        </Typography>
      </Box>
      {CURRENT_VIEW_TYPES.map((report) => (
        <RadioButton
          key={report.id}
          id={report.id}
          name={report.name}
          title={l(report.title)}
          description={l(report.description)}
          value={report.value}
          radioSelection={currentSelectedReport}
          onClick={handleClick}
        />
      ))}
    </Box>
  );
}

CurrentView.defaultProps = {
  onReportSelect: undefined,
  selectedReport: undefined,
  appliedFiltersCount: undefined,
};

export default CurrentView;
